// extracted by mini-css-extract-plugin
export var RecruitDiscover = "RecruitDiscover-module--RecruitDiscover--36gl5";
export var RecruitDiscover__inner = "RecruitDiscover-module--RecruitDiscover__inner--1hW3r";
export var RecruitDiscover__content = "RecruitDiscover-module--RecruitDiscover__content--1yw1V";